import { render, staticRenderFns } from "./Coupon_examine.vue?vue&type=template&id=32a274a6&scoped=true&"
import script from "./Coupon_examine.vue?vue&type=script&lang=js&"
export * from "./Coupon_examine.vue?vue&type=script&lang=js&"
import style0 from "./Coupon_examine.vue?vue&type=style&index=0&id=32a274a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a274a6",
  null
  
)

export default component.exports